import React from "react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { situations } from "../../data/content";
export function SituationsSection() {
  return <section className="bg-paper px-4 py-16 md:py-24" data-id="element-321" data-mp="3lf8c436lz6dm">
      <div className="mx-auto max-w-5xl" data-id="element-322" data-mp="3lcm462ft2ouv">
        <SectionHeading eyebrow="Does any of this sound familiar?" title="If you recognize these situations, this collection was designed with your learning needs in mind." data-id="element-323" data-mp="3qd9qwbx04jja" />
        <ol className="mt-10 grid gap-4 md:grid-cols-2 md:gap-5" data-id="element-324" data-mp="3gg56ohmpuy54">
          {situations.map((s, i) => <li key={s.title} className="flex gap-4 rounded-2xl bg-white p-5 shadow-sm ring-1 ring-line" data-id="element-325" data-mp="32gnoil3xej4q" data-mpi={i}>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-cta font-display text-lg font-black text-white" data-id="element-326" data-mp="37g06arfxx00g">
                {i + 1}
              </span>
              <div data-id="element-327" data-mp="15nu3zs0wleyx">
                <h3 className="font-display text-lg font-extrabold leading-snug text-ink" data-id="element-328" data-mp="15n29kkj1lna8">{s.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-muted" data-id="element-329" data-mp="2963vp5yywb5j">{s.text}</p>
              </div>
            </li>)}
        </ol>
        <div className="mx-auto mt-10 max-w-3xl space-y-3 text-center text-lg leading-relaxed text-muted" data-id="element-330" data-mp="2hzqnym3yuw9z">
          <p className="font-display text-xl font-extrabold text-ink" data-id="element-331" data-mp="2dxvbclgl4wgw">
            You don’t have to keep every examination detail in your head.
          </p>
          <p data-id="element-332" data-mp="1qawxzwnri4n7">
            I organized these educational resources to help you review the assessment process, document relevant
            findings, and approach clinical reasoning with greater structure.
          </p>
        </div>
        <div className="mt-10" data-id="element-333" data-mp="1uanwkmjj5p2a">
          <CtaButton label="Get the complete blueprint for $27" sub="One-time payment · Instant access · 7-day guarantee" data-id="element-334" data-mp="1u9cquh6iy78j" />
        </div>
      </div>
    </section>;
}